import { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import useStoreTimToa from "../../../store/useStoreTimToa";
import { Icons } from "../../spinner";
import { Info } from "@phosphor-icons/react"

export function WorkOccupation() {
  const [options, setOptions] = useState({});
  const { workOccupationData, loadingChartWorkOccupation } = useStoreTimToa(
    (state) => state
  );



  const updateOptions = () => {
    const option = {
      title: {
        text: 'Taxa de Ocupação',
        left: 'center',
        textStyle: {
          color: '#fff',
          fontSize: 16,
          fontWeight: 'bold'
        },
        top: 5
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: function (params: any) {
          return `${params[0].name}<br/>${params[0].value}h`;
        },
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "10%",
        top: "15%", // Aumentado para acomodar o título
        containLabel: true,
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: function (value: number) {
            return `${value}h`;
          },
          color: "#fff",
        },
      },
      xAxis: {
        type: "category",
        data: ["Horas Disponíveis", "Horas Trabalhadas", "Horas Não Ocupadas"],
        axisLabel: {
          color: "#fff",
          interval: 0,
          rotate: 0,
          align: 'center',
          width: 80,
          overflow: 'break'
        },
      },
      series: [
        {
          data: [
            {
              value: workOccupationData?.total_horas_disponiveis,
              name: "Horas Disponíveis",
              itemStyle: { color: "#4CAF50" },
            },
            {
              value: workOccupationData?.total_horas_trabalhadas,
              name: "Horas Trabalhadas",
              itemStyle: { color: "#2196F3" },
            },
            {
              value: workOccupationData?.total_horas_nao_ocupadas,
              name: "Horas Não Ocupadas",
              itemStyle: { color: "#FF9800" },
            },
          ],
          type: "bar",
          showBackground: true,
          backgroundStyle: {
            color: "rgba(180, 180, 180, 0.2)",
          },
          label: {
            show: true,
            position: "top",
            color: "#fff",
            formatter: function (params: any) {
              return `${params.value}h`;
            },
          },
        },
      ],
    };

    setOptions(option);
  };

  useEffect(() => {
    if (workOccupationData) {
      updateOptions();
    }
  }, [workOccupationData]);

  return (
    <>
      {workOccupationData ? (
        <div className="relative h-[450px] bg-gray-500 rounded-sm">
          {/* Ícone de informação com tooltip */}
          <div className="absolute top-2 right-2 z-10 group">
            <Info 
              className="h-5 w-5 text-white cursor-help" 
            />
            <div className="hidden group-hover:block absolute right-0 w-64 p-2 bg-gray-800 text-white text-sm rounded-md shadow-lg">
              Este gráfico mostra a distribuição das horas de trabalho, 
              indicando o total de horas disponíveis, horas efetivamente 
              trabalhadas e horas não ocupadas no período.
            </div>
          </div>
          <ReactECharts 
            option={options} 
            style={{ height: "450px", width: "100%" }} 
          />
        </div>
      ) : loadingChartWorkOccupation ? (
        <div className="h-[450px] bg-gray-500 flex justify-center items-center rounded-sm">
          <Icons.spinner className="h-12 w-12 animate-spin text-orange-300" />
        </div>
      ) : (
        <div className="h-[450px] bg-gray-500 flex justify-center items-center rounded-sm">
          <p className="bg-slate-100 p-2 text-gray-500 rounded-md font-extrabold">
            SEM DADOS
          </p>
        </div>
      )}
    </>
  );
}